import type { TaskItemStatus } from './types';

/** Matches Activities table date display (local calendar day). */
export function formatActivityTableDate(s: string | null | undefined): string {
  if (s == null || s === '') return '—';
  try {
    const d = new Date(s);
    return Number.isNaN(d.getTime())
      ? s
      : d.toLocaleDateString(undefined, {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        });
  } catch {
    return '—';
  }
}

export function activityDueIsOverdue(dueDate: string | null | undefined, status: TaskItemStatus): boolean {
  if (status === 3 || status === 4 || !dueDate) return false;
  const d = new Date(dueDate);
  if (Number.isNaN(d.getTime())) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d < today;
}

export function activityDueIsToday(dueDate: string | null | undefined): boolean {
  if (!dueDate) return false;
  const d = new Date(dueDate);
  if (Number.isNaN(d.getTime())) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  return d >= today && d < tomorrow;
}
